export const GAME_TIME_SECS = 1200;

export const ROUTES = {
	HOME: "/",
	REGISTER: "/register",
	PRESENTATION: "/presentation",
	START_GAME: "/start-game",
	START_GAME2: "/start-game2",
	START_GAME3: "/start-game3",
	START_GAME4: "/start-game4",
	START_GAME5: "/start-game5",
	TRANSITION_SCENARIOS: "/scenarios",

	SCENARIO1_INTRO: "/scenario1-intro",
	SCENARIO1_INTRO2: "/scenario1-intro2",
	SCENARIO1_INSTRUCTIONS: "/scenario1-instructions",

	SCENARIO2_INTRO: "/scenario2-intro",
	SCENARIO2: "/scenario2",
	SCENARIO2_INTRO2: "/scenario2-intro2",
	SCENARIO2_RESULTADOPETCT: "/scenario2-resultado-pet-ct",
	SCENARIO2_RETROALIMENTACION: "/scenario2-retroalimentacion",
	SCENARIO2_CLASIFICACION: "/scenario2-clasificacion",
	SCENARIO2_ALTOVOLUMEN: "/scenario2-alto-volumen",
	SCENARIO2_METASTASIS: "/scenario2-metastasis",
	SCENARIO2_MUJER: "/scenario2-mujer",
	SCENARIO2_FIN: "/scenario2-fin",

	SCENARIO3: "/scenario3",
	SCENARIO3_INTRO: "/scenario3-intro",
	SCENARIO3_FINALOSRESULTS: "/scenario3-final-os-results",
	SCENARIO3_PEACEI: "/scenario3-peace-i",
	SCENARIO3_ANTECEDENTES: "/scenario3-antecedentes",
	SCENARIO3_EVALUACION: "/scenario3-evaluacion",
	SCENARIO3_BIESPECIFICOS: "/scenario3-biespecificos",
	SCENARIO3_DESAFIO: "/scenario3-desafio",
	SCENARIO3_PISTAEVALUACIONGERIATRICOS: "/scenario3-pista-evaluacion-geriatricos",
	SCENARIO3_EVALUACIONGERIATRICOS: "/scenario3-evaluacion-geriatricos",
	SCENARIO3_ESCALAGERIATRICA: "/scenario3-escala-geriatrica",
	SCENARIO3_RETROALIMENTACION: "/scenario3-retroalimentacion",
	SCENARIO3_FIN: "/scenario3-fin",
	SCENARIO3_FIN2: "/scenario3-fin2",

	SCENARIO4_INTRO: "/scenario4-intro",
	SCENARIO4: "/scenario4",
	SCENARIO4_SUSPENSIONTRATAMIENTO: "/scenario4-suspension-tratamiento",
	SCENARIO4_RETROALIMENTACION: "/scenario4-retroalimentacion",
	SCENARIO4_RADIOTERAPIA: "/scenario4-radioterapia",
	SCENARIO4_PREGUNTA9: "/scenario4-pregunta9",
	SCENARIO4_FIN: "/scenario4-fin",

	SCENARIO5_INTRO: "/scenario5-intro",
	SCENARIO5: "/scenario5",
	SCENARIO5_APALUTAMIDA: "/scenario5-apalutamida",
	SCENARIO5_SEGUIMIENTO2: "/scenario5-seguimiento2",
	SCENARIO5_RETROALIMENTACION: "/scenario5-retroalimentacion",
	SCENARIO5_IMPACTO: "/scenario5-impacto",
	SCENARIO5_CONCLUSION: "/scenario5-conclusion",
	SCENARIO5_RESULTADOS: "/scenario5-resultados",
	SCENARIO5_FIN: "/scenario5-fin",

	SUPERTEST_INTRO: "/supertest-intro",
	SUPERTEST_INSTRUCTIONS: "/supertest-instructions",
	SUPERTEST: "/supertest",
	SUPERTEST_2: "/supertest-2",
	SUPERTEST_3: "/supertest-3",

	FINAL_SCENE: "/final-scene",
	CONGRATULATIONS: "/congratulations",
	END: "/end",
	RESULTS: "/results",
	GAMEOVER: "/gameover",

	WARMUP: "/warmup"
};

export const SCENARIOS = {
	SCENARIO_1: "---",
	SCENARIO_2: "65127bfe70cc5310ac640cbd",
	SCENARIO_3: "65127cfd7b2f5959ecc41031",
	SCENARIO_4: "65127d067b2f5959ecc41033",
	SCENARIO_5: "65127d167b2f5959ecc41037",
	SUPERTEST: "---",
};

export const QUIZZES = {
	ESTUDIOS_EXTENSION: "65127e987b2f5959ecc4104c",
	CLASIFICACION_PACIENTE: "65127f5d7b2f5959ecc4105a",
	ALTO_VOLUMEN: "65127fac7b2f5959ecc41061",
	
	OPCIONES_TRATAMIENTO: "651280137b2f5959ecc41063",
	ANTECEDENTES_TRATAMIENTO: "6513e9b7eb4ed56660961616",
	BIESPECIFICOS: "69b91b99bff9a735fcb91651",
	DESAFIO: "69b93a17bff9a735fcb91657",
	EVALUACION_GERIATRICOS: "6512801d7b2f5959ecc41065",

	AJUSTE_DE_DOSIS:"6512802c7b2f5959ecc41067",
	SUSPENSION_DE_TRATAMIENTO: "651280ca7b2f5959ecc4106f",
	RADIOTERAPIA_O_PROSTATECTOMIA: "651280f07b2f5959ecc41076",
	PREGUNTA9: "69b95ae4bff9a735fcb9165d",
	
	BENEFICIO_APALUTAMIDA: "651280f37b2f5959ecc41078",
	IMPACTO_SUPERVIVENCIA: "651280f67b2f5959ecc4107a",
	
};

const FIRST_STAMP_QUIZ_ID = QUIZZES.NUTRICION_CLINICA;
const SECOND_STAMP_QUIZ_ID = QUIZZES.TECNICAS_VALORACION;
const THIRD_STAMP_QUIZ_ID = QUIZZES.CASO_CLINICO_4;
const FOURTH_STAMP_QUIZ_ID = QUIZZES.TIPO_NUTRICION;
const FIFTH_STAMP_QUIZ_ID = QUIZZES.AFIRMACION_FALSA_ENTERAL;

export const STAMPS_QUIZZES = [
	FIRST_STAMP_QUIZ_ID,
	SECOND_STAMP_QUIZ_ID,
	THIRD_STAMP_QUIZ_ID,
	FOURTH_STAMP_QUIZ_ID,
	FIFTH_STAMP_QUIZ_ID,
];

export const QUESTION_ALREADY_ANSWERED_BUTTON = `<div class="d-flex align-items-center justify-content-center px-3">
		AVANZAR
	</div>`;

export const QUESTION_ALREADY_ANSWERED_TEXT = `<div>
		<div class="txt22">Ya has resuelto esta prueba anteriormente.</div>
		<div class="txt22 mt-2">¡Sigue adelante!</div>
	</div>`;
